import 'core-js/stable';
import 'regenerator-runtime/runtime';
import '@hotwired/turbo-rails';
import 'chartkick/chart.js';

// Import and start extra dependencies
import '../scripts';
import { scrollToInvalid } from '../scripts/scroll';

// Setup Alpine and components
import Alpine from 'alpinejs';
import autocomplete from '../alpine/auto-complete';
import autoFlag from '../alpine/auto-flag';
import autoUpdate from '../alpine/auto-update';
import beforeUnload from '../alpine/before-unload';
import checkboxDropdown from '../alpine/checkbox-dropdown';
import clipboard from '../alpine/clipboard';
import combobox from '../alpine/combobox';
import downloadGraph from '../alpine/download-graph';
import dropdown from '../alpine/dropdown';
import fileUpload from '../alpine/file-upload';
import formBuilder from '../alpine/form-builder';
import googleMapsAdmin from '../alpine/google-maps-admin';
import modal from '../alpine/modal';
import moderationAttachments from '../alpine/moderation-attachments';
import moderationEntryLoader from '../alpine/moderation-entry-loader';
import moderationCommentFilters from '../alpine/moderation-comment-filters';
import moderationEntryFilters from '../alpine/moderation-entry-filters';
import moderationMails from '../alpine/moderation-mails';
import moderationModal from '../alpine/moderation-modal';
import organizationSettings from '../alpine/organization-settings';
import projectPath from '../alpine/project-path';
import projectSettings from '../alpine/project-settings';
import sidebar from '../alpine/sidebar';
import sortableList from '../alpine/sortable-list';
import sortableHomepage from '../alpine/sortable-homepage';
import settingsWizard from '../alpine/settings-wizard';
import summaryClipboard from '../alpine/summary-clipboard';
import { topicSwitcher } from '../alpine/topic-switcher';
import uploadFiles from '../alpine/upload-files';
import urlPicker from '../alpine/url-picker';

window.Alpine = Alpine;
Alpine.data('autocomplete', autocomplete);
Alpine.data('autoFlag', autoFlag);
Alpine.data('autoUpdate', autoUpdate);
Alpine.data('beforeUnload', beforeUnload);
Alpine.data('checkboxDropdown', checkboxDropdown);
Alpine.data('clipboard', clipboard);
Alpine.data('combobox', combobox);
Alpine.data('downloadGraph', downloadGraph);
Alpine.data('dropdown', dropdown);
Alpine.data('fileUpload', fileUpload);
Alpine.data('formBuilder', formBuilder);
Alpine.data('googleMapsAdmin', googleMapsAdmin);
Alpine.data('modal', modal);
Alpine.data('moderationAttachments', moderationAttachments);
Alpine.data('moderationEntryLoader', moderationEntryLoader);
Alpine.data('moderationCommentFilters', moderationCommentFilters);
Alpine.data('moderationEntryFilters', moderationEntryFilters);
Alpine.data('moderationMails', moderationMails);
Alpine.data('moderationModal', moderationModal);
Alpine.data('organizationSettings', organizationSettings);
Alpine.data('projectPath', projectPath);
Alpine.data('projectSettings', projectSettings);
Alpine.data('sidebar', sidebar);
Alpine.data('sortableList', sortableList);
Alpine.data('sortableHomepage', sortableHomepage);
Alpine.data('settingsWizard', settingsWizard);
Alpine.data('summaryClipboard', summaryClipboard);
Alpine.data('topicSwitcher', topicSwitcher);
Alpine.data('uploadFiles', uploadFiles);
Alpine.data('urlPicker', urlPicker);

document.addEventListener('DOMContentLoaded', () => {
  Alpine.start();
  scrollToInvalid();
});
